// extracted by mini-css-extract-plugin
export var black = "_27-6";
export var brand = "_27-1";
export var ddefault = "_27-0";
export var error = "_27-3";
export var gray = "_27-2";
export var highContrast = "_27-8";
export var outline = "_27-7";
export var success = "_27-5";
export var warning = "_27-4";